<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="adams-making">
<h1>Adam’s Making</h1>
<p style="text-align: center;"><em>—after Yeats’ “Adam’s Curse”</em></p><br/>
<p style="text-align: center;">The dogs smelled it—some rattling scratch. I shot you a look.</p>
<p style="text-align: center;">“So far my new boss rubber stamps the risk as if she’s played no part.</p><br/>
<p style="text-align: center;">“The oldest irony in the book— whatever form it takes,</p>
<p style="text-align: center;">love of work or working at love— we overreach the real for the fake.”</p><br/>
<p style="text-align: center;">You said, “But if it’s love it’s real. Although you mince around at work,</p>
<p style="text-align: center;">mastering new dance steps, she hums the company line by heart.”</p><br/>
<p style="text-align: center;">Like you and me, whispered the pause.</p>
<p style="text-align: center;">Like gender and culture; the open range, the safer paths.</p>
<p style="text-align: center;">Closed gates, unlocked, domesticate.</p><br/>
<p style="text-align: center;">“Any curse is our own making,” I said, “and work enough</p>
<p style="text-align: center;">to free the other from tether’s end.” Twilight leaned into the shadowed hush.</p><br/>
<p style="text-align: center;">We felt the moonless sunset pressing close as a naked scent,</p>
<p style="text-align: center;">till barking, scrambling dogs flushed out the raccoon whose head was stuck in a jar.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?31173305